<template>
  <div class="car-popular" v-show="cars.length > 0" @click.stop>
    <div class="car-popular__container">
      <!-- 标题栏 -->
      <div class="car-popular__title">
        <div class="car-popular__heading">Popular Cars</div>
        <a :href="allCarsLink" class="car-popular__view">
          <div class="car-popular__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-popular__icon" alt="">
        </a>
      </div>

      <!-- 内容区域 -->
      <div class="car-popular__content" v-if="cars.length >= 5">

        <!-- 左侧大卡片 -->
        <a :href="getDetailLink(cars[0])" class="car-popular__main-card">
          <!-- 车辆图片 -->
          <img :src="cars[0].image" class="car-popular__main-pic" alt="">

          <!-- 基本信息区域 -->
          <div class="car-popular__main-info">
            <!-- 品牌和车型 -->
            <div class="car-popular__card-title">
              <img :src="cars[0].logo" class="car-popular__logo" alt="">
              <div class="car-popular__name">
                <div class="car-popular__model">{{ cars[0].model }}</div>
                <div class="car-popular__brand">{{ cars[0].brand }}</div>
              </div>
            </div>
          </div>
        </a>

        <!-- 右侧小卡片网格 -->
        <div class="car-popular__small-cards">
          <a v-for="index in 4" :key="`small-card-${index}`" class="car-popular__small-card"
            :href="getDetailLink(cars[index])">
            <!-- 车辆图片 -->
            <img :src="cars[index].image" class="car-popular__small-pic" alt="">

            <!-- 品牌和名称 -->
            <div class="car-popular__small-info">
              <div class="car-popular__small-left">
                <div class="car-popular__small-logo">
                  <img :src="cars[index].logo" alt="">
                </div>
                <div class="car-popular__small-text">
                  <div class="car-popular__small-model">{{ cars[index].model }}</div>
                  <div class="car-popular__small-brand">{{ cars[index].brand }}</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarPopular',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    allCarsLink () {
      const currentChannel = this.$route.params.channel;
      const query = this.$route.query;
      const queryString = Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';
      let path = '/car-list';
      if (currentChannel) {
        path = `/${currentChannel}${path}`;
      }
      return `${path}${queryString}`;
    }
  },
  data () {
    return {
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    this.fetchPopularCars();
  },
  methods: {
    // 获取热门车辆数据
    async fetchPopularCars () {
      this.loading = true;
      this.error = null;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.state.domainConfig?.themeFilters || {};

        console.log(themeFilters);

        // 调用global.js中的getRecommendedPopularCars方法获取数据
        const res = await this.$global.server.getRecommendedPopularCars(themeFilters);
        if (res.code === 200) {
          // 处理API返回的数据，确保至少有5条数据才显示
          const apiData = res.data || [];
          if (apiData.length >= 5) {
            const processedData = apiData.slice(0, 5).map(item => {
              // 从photos字段提取第一张图片作为封面
              const photos = item.photos ? item.photos.split(',') : [];
              const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

              // 返回处理后的数据，映射字段名称
              return {
                id: item.id,
                model: item.name, // API中是name字段，映射为model
                brand: item.brand,
                logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
                year: item.year || item.marketTime?.substring(0, 4) || '-',
                category: item.purpose || '-', // 使用purpose字段作为category
                bodyType: item.type || '-', // 使用type字段作为bodyType
                price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
                image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
                speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-' // 添加's'后缀
              };
            });

            this.cars = processedData;
            console.log('[CarPopular] 获取热门车辆:', this.cars.length);
          } else {
            // 如果数据少于5条，则不显示
            this.cars = [];
            console.log('[CarPopular] 获取的热门车辆数据不足5条，不显示');
          }
        } else {
          throw new Error(res.message || 'Failed to get popular cars');
        }
      } catch (error) {
        console.error('[CarPopular] 获取热门车辆数据错误:', error);
        this.error = error.message || 'Failed to get popular cars';
        this.cars = [];
      } finally {
        this.loading = false;
      }
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    getDetailLink (car) {
      if (!car || !car.id) {
        return '#';
      }
      const currentChannel = this.$route.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const query = this.$route.query;
      const queryString = Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';

      let path = `/cars/${formattedName}/${car.id}`;
      if (currentChannel) {
        path = `/${currentChannel}${path}`;
      }

      return `${path}${queryString}`;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-popular {
	padding: rem(50) rem(120);
	background: #ffffff;

	&__container {
		max-width: rem(1200);
		margin: 0 auto;
	}

	&__title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(20);
	}

	&__heading {
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		color: #050b20;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(10);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		width: rem(14);
		height: rem(14);
	}

	&__content {
		display: flex;
		flex-direction: row;
		width: 100%;
		gap: rem(30); // 横向间距30
		// min-height: rem(350); /* 添加最低高度确保布局稳定 */
	}

	&__loading {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__loading-text {
		font-size: rem(18);
		font-weight: 700;
		color: #405ff2;
	}

	&__error {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__error-text {
		font-size: rem(18);
		font-weight: 700;
		color: #ff0000;
	}

	&__main-card {
		flex: 0 0 calc(50% - rem(15));
		position: relative;
		border: 1px solid #e9e9e9;
		border-radius: rem(12);
		overflow: hidden;
		cursor: pointer;
	}

	&__main-pic {
		width: 100%;
		height: rem(391); // 根据图片高度调整
		object-fit: cover;
	}

	&__speed {
		position: absolute;
		top: rem(6);
		left: rem(6);
		display: flex;
		background: rgba(0, 0, 0, 0.5);
		border-radius: rem(8);
		overflow: hidden;
		z-index: 2;
	}

	&__speed-value {
		background: rgba(0, 0, 0, 0.5);
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-number {
		color: #ffffff;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 700;
	}

	&__speed-label {
		padding: rem(4) rem(8);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-text {
		color: #ffffff;
		font-size: rem(10);
		line-height: rem(10);
		font-weight: 400;
	}

	&__main-info {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
		padding: rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__card-title {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: rem(12);
	}

	&__name {
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__model {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		color: #ffffff;
	}

	&__brand {
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		color: #ffffff;
	}

	&__logo {
		width: rem(36);
		height: rem(36);
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: cover;
	}

	&__details {
		display: flex;
		justify-content: flex-start;
		gap: rem(16);
	}

	&__detail-item {
		display: flex;
		align-items: center;
		gap: rem(8);
		font-size: rem(12);
		line-height: rem(12);
		color: #ffffff;
	}

	&__detail-icon {
		width: rem(16);
		height: rem(16);
		filter: brightness(0) invert(1);
	}

	&__price {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__price-text {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		color: #ffffff;
	}

	&__price-link {
		width: rem(16);
		height: rem(16);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__arrow {
		width: rem(16);
		height: rem(16);
		filter: brightness(0) invert(1);
	}

	&__small-cards {
		flex: 0 0 calc(50% - rem(15));
		display: flex;
		flex-wrap: wrap;
		gap: rem(20); // 纵向间距20
	}

	&__small-card {
		flex: 0 0 calc(50% - rem(10));
		height: calc(50% - rem(10));
		position: relative;
		border: 1px solid #e9e9e9;
		border-radius: rem(12);
		overflow: hidden;
		cursor: pointer;
	}

	&__small-pic {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__small-info {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
		padding: rem(12);
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__small-left {
		display: flex;
		align-items: center;
		gap: rem(12);
	}

	&__small-logo {
		width: rem(36);
		height: rem(36);
	}

	&__small-logo img {
		width: 100%;
		height: 100%;
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: contain;
	}

	&__small-text {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		flex: 1;
	}

	&__small-arrow {
		width: rem(16);
		height: rem(16);
	}

	&__arrow-icon {
		width: 100%;
		height: 100%;
		filter: brightness(0) invert(1);
	}

	&__small-model {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		color: #ffffff;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	&__small-brand {
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		color: #ffffff;
	}
}

// 修改移动端适配
.detect_deviece_mobile {
	.car-popular {
		padding: rem(30) rem(16);

		&__content {
			flex-direction: column;
			gap: rem(16);
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}

		&__main-card {
			flex: 0 0 100%;
		}

		&__small-cards {
			flex: 0 0 100%;
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			gap: rem(12);
			padding-bottom: rem(10); // 为滚动条预留空间
			// 隐藏滚动条但保留滚动功能
			scrollbar-width: none; /* Firefox */
			-ms-overflow-style: none; /* IE and Edge */
			&::-webkit-scrollbar {
				display: none; /* Chrome, Safari, Opera */
			}
			// 添加负边距解决边缘被切断问题
			margin: 0 rem(-16);
			padding: 0 rem(16);
			width: calc(100% + rem(32));
		}

		&__small-card {
			flex: 0 0 calc(70% - rem(6));
			min-width: rem(220);
			height: rem(150);
			margin-right: 0;
		}

		&__card-title {
			gap: rem(12);
		}

		&__small-info {
			gap: rem(12);
			justify-content: space-between; // 确保logo和名称在左边，箭头在右边
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-popular {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-popular {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
	}
}
</style> 